import React from 'react'
import styled from 'styled-components'
import { PopoverModal } from 'sutra/components/PopoverModal/PopoverModal'

import { darkBlueFontColor } from 'assets/styles/variables'

export interface TrackEmailOptInModalProps {
  isOpen: boolean
  agentName: string
  /** True while the answer mutation is in flight. Disables both buttons. */
  loading?: boolean
  /** Fired when the user clicks "Turn on emails". */
  onOptIn: () => void
  /** Fired when the user clicks "Not now", presses Escape, clicks the
   *  backdrop, or hits the close icon. All paths are equivalent. */
  onDecline: () => void
}

export const TrackEmailOptInModal: React.FC<TrackEmailOptInModalProps> = ({
  isOpen,
  agentName,
  loading = false,
  onOptIn,
  onDecline,
}) => (
  <PopoverModal
    title="Get email updates from this agent?"
    isOpen={isOpen}
    onOk={onOptIn}
    onClose={onDecline}
    okText="Turn on emails"
    cancelText="Not now"
    confirmLoading={loading}
    okButtonProps={{ disabled: loading }}
    cancelButtonProps={{ disabled: loading }}
    width={500}
    content={
      <>
        <Body>
          We&apos;ll email you about new issues from{' '}
          <AgentName>{agentName}</AgentName> and updates on issues you track
          from it.
        </Body>
        <Footer>Change anytime in Agent settings.</Footer>
      </>
    }
  />
)

const Body = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: ${darkBlueFontColor};
  margin: 8px 0 12px 0;
`

const AgentName = styled.strong`
  font-weight: 600;
  color: ${darkBlueFontColor};
`

const Footer = styled.p`
  font-size: 12px;
  color: ${darkBlueFontColor};
  opacity: 0.6;
  margin: 0;
`
